import Navigation from './Navigation.vue';
import Menu from './Menu.vue';
import ShowMenus from './ShowMenus.vue';
import JourneysPreview from './JourneysPreview.vue';
import MapPreview from './MapPreview.vue';
import FeedbackDialog from './FeedbackDialog.vue';
import ModalDeudor from './ModalDeudor.vue';
import ModalTyC from './ModalTyC.vue';
import ReportsPreview from './ReportsPreview.vue';
import SettingsPreview from './SettingsPreview.vue';

export {
    Navigation,
    ShowMenus,
    Menu,
    JourneysPreview,
    MapPreview,
    FeedbackDialog,
    ModalDeudor,
    ModalTyC,
    ReportsPreview,
    SettingsPreview
};
